export default {
	add(itemid, qty, sku, cb, ecb) {
		this.http
			.post(`/shoppingcart/add/${itemid}/${qty}`, sku)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getAll(cb, ecb) {
		this.http
			.post('/shoppingcart/getByUser/')
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	checkout(items, cb, ecb) {
		this.http
			.post('/shoppingcart/checkoutCart/', {
				items: items
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	alterQty(scid, to, cb, ecb) {
		this.http
			.get('/shoppingcart/alterQty/' + scid + '/' + to, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	remove(scid, cb) {
		this.http
			.get('/shoppingcart/remove/' + scid, {})
			.then((r) => cb && cb(r))
	},
	removeAll(cb) {
		this.http.post('/shoppingcart/removeAll/', {}).then((r) => cb && cb(r))
	},
	getDeliveryTypes(cb) {
		this.http
			.get('/shoppingcart/getDeliveryTypes/', {})
			.then((r) => cb && cb(r))
	},
	getDeliveryFee(params, cb) {
		this.http
			.post('/shoppingcart/getDeliveryFee/', params)
			.then((r) => cb && cb(r))
	},
	checkoutValidate(form, cb) {
		this.http
			.post('/shoppingcart/checkoutValidate/', form)
			.then((r) => cb && cb(r))
	},
	checkoutConfirm(form, cb, ecb) {
		this.http
			.post('/shoppingcart/checkoutConfirm/', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
